import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const viewsText = comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views.toString();

  return (
    <article data-product-shop>
      <Link
        to={`/article/${comic.slug}`}
        className="group block"
      >
        <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
          <img
            src={comic.coverImage}
            alt={`${comic.title} - 韩国漫画免费看`}
            title={`${comic.title} - 韩漫在线阅读`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-2 left-2 flex flex-col gap-1.5">
            {comic.featured && (
              <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent-500 text-background-50">
                精选
              </span>
            )}
            {comic.isNew && (
              <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-primary-500 text-background-50">
                新作
              </span>
            )}
          </div>
          <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full text-xs font-medium bg-background-900/70 text-background-50">
            {comic.status}
          </div>
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
            <div className="flex items-center gap-2 text-xs text-background-50/90">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-star-fill text-primary-400 text-xs"></i>
              </div>
              <span>{comic.rating}</span>
              <span className="opacity-50">|</span>
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-eye-line text-xs"></i>
              </div>
              <span>{viewsText}</span>
            </div>
          </div>
        </div>
        <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-1">
          {comic.author} / {comic.artist}
        </p>
        <div className="flex items-center gap-2 mt-2 flex-wrap">
          {comic.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>
      </Link>
    </article>
  );
}